<script lang="ts" setup>
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { EditBusinessHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import EditBusinessButton from './EditBusinessButton.vue';
import TableCell from '../TableCell.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    editBusinessHeaderKey: EditBusinessHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isEditing: boolean;
    isBold: boolean;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {}
);

const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const baseTableContentViewModel = new BaseTableContentViewModel();

const headerItemPath = computed(() => {
  if (!props.header.propertyPath) return '--';
  let buf = props.item;
  props.header.propertyPath.paths.forEach((path) => {
    buf = buf[path];
  });
  return buf ?? '--';
});
</script>
<template>
  <TableCell
    :class="[baseTableContentViewModel.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: baseTableContentViewModel.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    text-align="left"
    :table-content-property="header"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <template v-if="header.key === 'editBusiness'">
      <EditBusinessButton class="edit-business" :item="item" />
    </template>
    <template v-else>
      <span class="table-cell-content">{{ headerItemPath }}</span>
    </template>
  </TableCell>
</template>
<style lang="scss" scoped>
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  padding-left: 0 !important;
  padding-right: 0 !important;
}

.edit-business {
  height: 20px;
  width: 72px;
  font-size: $fontSizeSS;
  line-height: 12px;
  font-weight: 400;
  text-align: center;
  padding: 2px 4px;
}
</style>
